module.exports = __webpack_public_path__ + "img/charging101.80a6c42f.png";